<template>
  <UIButton class="button-secondary" :class="customClasses"><slot /></UIButton>
</template>
<script setup lang="ts">
defineProps<{
  customClasses?: string;
}>();
</script>
<style lang="scss" scoped>
.button-secondary {
  background: #d9eff6;
  color: #3A3D44;
}

</style>
